module.exports = __webpack_public_path__ + "img/time.7683b2f1.svg";